import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import useReveal from "../useReveal";
import "./Style.scss";

const traderProducts = [
  {
    icon: "fa-chart-line",
    title: "Online Trading",
    subtitle: "Speed and secure trading",
    text: "A clean web trading platform with charting tools and essentials for everyday execution.",
  },
  {
    icon: "fa-robot",
    title: "Algo Trading",
    subtitle: "Algorithmic access",
    text: "Access algorithms developed by Algoquant Global, designed for disciplined execution.",
  },
  {
    icon: "fa-code",
    title: "API Trading",
    subtitle: "Build your edge",
    text: "Connect through our execution stack and integrate your own strategies with confidence.",
  },
];

const investorProducts = [
  {
    icon: "fa-briefcase",
    title: "PMS",
    subtitle: "Portfolio management",
    text: "Work with Algoquant Global wealth managers to manage and grow your portfolio.",
  },
  {
    icon: "fa-piggy-bank",
    title: "Mutual Funds",
    subtitle: "Long-term building blocks",
    text: "Invest in mutual funds with guidance that keeps your long-term goals in focus.",
  },
  {
    icon: "fa-building",
    title: "IPO",
    subtitle: "Primary market access",
    text: "Participate in upcoming IPOs and invest early in companies that fit your thesis.",
  },
];

const CardContainer = () => {
  const [activeTab, setActiveTab] = useState("trader");
  const revealRef = useReveal();
  const products = activeTab === "trader" ? traderProducts : investorProducts;

  return (
    <section className="homeProducts">
      <Container className="homeProducts__inner homeReveal" ref={revealRef}>
        <div className="homeProducts__intro">
          <h2>Products built around you</h2>
          <p>Choose how you engage with the markets — then explore what fits.</p>
        </div>

        <div
          className="homeProducts__tabs"
          role="tablist"
          aria-label="Product audience"
        >
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === "trader"}
            className={`homeProducts__tab ${
              activeTab === "trader" ? "is-active" : ""
            }`}
            onClick={() => setActiveTab("trader")}
          >
            <i className="fas fa-chart-line" aria-hidden="true" />
            <span>
              <strong>I am a Trader</strong>
              <small>Short-term goals and daily markets</small>
            </span>
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={activeTab === "investor"}
            className={`homeProducts__tab ${
              activeTab === "investor" ? "is-active" : ""
            }`}
            onClick={() => setActiveTab("investor")}
          >
            <i className="fas fa-seedling" aria-hidden="true" />
            <span>
              <strong>I am an Investor</strong>
              <small>Long-term goals and wealth building</small>
            </span>
          </button>
        </div>

        <Row className="g-3 g-lg-4 homeProducts__grid">
          {products.map((item) => (
            <Col md={4} key={item.title}>
              <article className="homeProducts__tile">
                <span className="homeProducts__icon" aria-hidden="true">
                  <i className={`fas ${item.icon}`} />
                </span>
                <h3>{item.title}</h3>
                <h4>{item.subtitle}</h4>
                <p>{item.text}</p>
              </article>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default CardContainer;
